var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import BaseText from '../../../shared/styling/BaseText/BaseText';
const BaseLink = styled(BaseText) `
  color: ${({ theme, dark }) => (dark ? theme.colors.text01 : theme.colors.interactivePrimary01)};
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    ${({ theme, darkHover }) => (darkHover ? `color: ${theme.colors.text01}` : '')}
  }
`;
const LinkComponent = (_a, ref) => {
    var { onClick, href, dark, darkHover, children } = _a, delegated = __rest(_a, ["onClick", "href", "dark", "darkHover", "children"]);
    return (_jsx(BaseLink, Object.assign({}, delegated, { ref: ref, as: "a", dark: dark, darkHover: darkHover, href: href, onClick: onClick }, { children: children }), void 0));
};
export const Link = forwardRef(LinkComponent);
export default Link;
//# sourceMappingURL=Link.js.map